var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--referral_hero-banner referral-hero-banner tw-flex tw-justify-center tw-relative tw-bg-contain tw-overflow-hidden"
  }, [_c('nuxt-img', {
    staticClass: "tw-object-contain tw-max-w-full tw-h-auto min-[1110px]:tw-h-[400px]",
    attrs: {
      "src": "/assets/images/referral/hero-header-banner-referral.svg",
      "width": "1440",
      "height": "400",
      "alt": "referral-hero-banner",
      "loading": "eager"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }